import DeltaCounts from "components/DeltaCounts";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { getStackPullRequestLatestRun } from "../../../helpers";
import StackPullRequestsTableGroupCell from "../../GroupCell";
import { StackPullRequestsTablePullRequestCellProps } from "../types";

const StackPullRequestsTablePullRequestDeltaCell = ({
  item: pullRequest,
  isAnsible,
  ...cellProps
}: StackPullRequestsTablePullRequestCellProps) => {
  const delta = getStackPullRequestLatestRun(pullRequest.runs)?.delta;

  return (
    <StackPullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      {!delta && <TableCellEmpty />}

      {!!delta && (
        <DeltaCounts
          size="small"
          align="start"
          variant="flexible"
          direction="column"
          delta={delta}
          isAnsible={isAnsible}
        />
      )}
    </StackPullRequestsTableGroupCell>
  );
};

export default StackPullRequestsTablePullRequestDeltaCell;
